export const ROLES = ["admin", "member", "guest"];

export const ROLE_LABELS = {
  owner: "Propriétaire",
  admin: "Administrateur",
  member: "Membre",
  guest: "Invité",
};

export const ALL_PERMISSIONS = [
  "CREATE_MEETING",
  "ATTEND_MEETING",
  "CREATE_ANNOUNCEMENT",
  "DELETE_OWN_ANNOUNCEMENT",
  "DELETE_ANY_ANNOUNCEMENT",
  "CREATE_GROUP",
  "DELETE_GROUP",
  "MANAGE_WORKSPACE_SETTINGS",
  "CREATE_WORKSPACE_INVITATION",
  "LEAVE_WORKSPACE",
  "DELETE_WORKSPACE",
  "MANAGE_FILES",
  "CAN_WRITE_A_MESSAGE",
  "CAN_WRITE_A_MESSAGE_TO_OWNER",
  "CAN_WRITE_A_MESSAGE_TO_ADMIN",
];

export const PERMISSION_LABELS = {
  CREATE_MEETING: "Créer des réunions",
  ATTEND_MEETING: "Participer aux réunions",
  CREATE_ANNOUNCEMENT: "Publier des annonces",
  DELETE_OWN_ANNOUNCEMENT: "Supprimer ses annonces",
  DELETE_ANY_ANNOUNCEMENT: "Supprimer toute annonce",
  CREATE_GROUP: "Créer des groupes",
  DELETE_GROUP: "Supprimer des groupes",
  MANAGE_WORKSPACE_SETTINGS: "Gérer les paramètres",
  CREATE_WORKSPACE_INVITATION: "Inviter des membres",
  LEAVE_WORKSPACE: "Quitter l'espace",
  DELETE_WORKSPACE: "Supprimer l'espace",
  MANAGE_FILES: "Gérer les fichiers (base de connaissances de Pélagie)",
  CAN_WRITE_A_MESSAGE: "Peut écrire des messages",
  CAN_WRITE_A_MESSAGE_TO_OWNER: "Peut écrire au propriétaire",
  CAN_WRITE_A_MESSAGE_TO_ADMIN: "Peut écrire aux administrateurs",
};
